<div class="mb-2">
  <mat-expansion-panel class="accordion accordion-maintenance accordion-default">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="index-number">{{ index + 1 }}</span> 
        Elemento : {{ getElementTypeName(formGroup.get('elementType')?.value) }} -
        {{ formGroup.get('labelName')?.value || 'Nuevo elemento' }} 
      </mat-panel-title>
      <button class="button button-danger button-xs mr-2" (click)="removeElement()">
        <i class="fas fa-trash-can" aria-hidden="true"></i>
      </button>
    </mat-expansion-panel-header>
    <div [formGroup]="formGroup" class="element-content">
      <!-- Orden y Requerido fields -->
      <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-5">
        <div class="md:col-span-5">
          <label>Nombre de la etiqueta</label>
          <input class="input" type="text" formControlName="labelName" placeholder="Nombre de la etiqueta">
          <div *ngIf="formGroup.get('labelName')?.invalid && formGroup.get('labelName')?.touched" class="text-red-500">
            Nombre de la etiqueta es requerido.
          </div>
        </div>
        <div class="md:col-span-3">
          <label>Tipo de elemento</label>
          <mat-select class="select" formControlName="elementType" (selectionChange)="isComboBoxSelected()">
            <mat-option *ngFor="let element of elements" [value]="element.id">{{ element.name }}</mat-option>
          </mat-select>
          <div *ngIf="formGroup.get('elementType')?.invalid && formGroup.get('elementType')?.touched" class="text-red-500">
            Tipo de elemento es requerido.
          </div>
        </div>
        <div class="md:col-span-2">
          <input class="input mt-5" type="number" formControlName="order" placeholder="Orden">
          <div *ngIf="formGroup.get('order')?.invalid && (formGroup.get('order')?.dirty || formGroup.get('order')?.touched)" class="text-red-500">
            El orden es obligatorio.
          </div>
        </div>
        <div class="md:col-span-2">
          <mat-checkbox class="mt-5" formControlName="required">Requerido</mat-checkbox>
        </div>
        <!-- Botón para abrir el modal de visación -->
        <div class="md:col-span-4" *ngIf="isMaintenanceUpdate" style="background-color: #fbd9a3; padding: 1rem; border-radius: 0.5rem;">
          <p>
            El siguiente elemento debe ser aprobado antes de que se empiece a utilizar en la mantención seleccionada.
            Una vez termine su configuración presione el botón “Notificar Cambio” para dar curso a la solicitud.
          </p>
          <button mat-button color="primary" (click)="openVisationModal()" style="background-color: #f59e0b; color: white; border-radius: 0.5rem; padding: 0.5rem 1rem;">
            Agregar Visación
          </button>
        </div>
        <!--
          <mat-form-field appearance="outline" class="order-field">
            <mat-label>Orden</mat-label>
            <input matInput type="number" formControlName="order" placeholder="Orden">
          </mat-form-field>
          <mat-checkbox formControlName="required">Requerido</mat-checkbox>
        -->
      </div>
      <!-- End of Orden y Requerido fields -->
       <!--
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Nombre de la etiqueta</mat-label>
          <input matInput formControlName="labelName" placeholder="Nombre de la etiqueta">
          <div *ngIf="formGroup.get('labelName')?.invalid && formGroup.get('labelName')?.touched" class="text-red-500">
            Nombre de la etiqueta es requerido.
          </div>
        </mat-form-field>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Tipo de elemento</mat-label>
          <mat-select formControlName="elementType" (selectionChange)="isComboBoxSelected()">
            <mat-option *ngFor="let element of elements" [value]="element.id">{{ element.name }}</mat-option>
          </mat-select>
          <div *ngIf="formGroup.get('elementType')?.invalid && formGroup.get('elementType')?.touched" class="text-red-500">
            Tipo de elemento es requerido.
          </div>
        </mat-form-field>
      -->
      <div *ngIf="isComboBoxSelected()" class="combobox-options">
        <div formArrayName="options">
          <div *ngFor="let optionCtrl of optionsFormArray.controls; let optionIndex = index" [formGroupName]="optionIndex">
            <div class="combobox-option">
              <div class="md:flex justify-between items-end">
                <div class="w-full max-w-[200px]">
                  <label>Opción</label>
                  <mat-select class="select select-sm" formControlName="id">
                    <mat-option *ngFor="let option of options" [value]="option.id">{{ option.name }}</mat-option>
                  </mat-select>
                  <div *ngIf="optionCtrl.get('id')?.invalid && optionCtrl.get('id')?.touched" class="text-red-500">
                    Opción es requerida.
                  </div>
                </div>
                <div>
                  <button class="button button-danger button-xs mr-2" (click)="removeOption(optionIndex)">
                    <i class="fas fa-trash-can" aria-hidden="true"></i>
                  </button>
                </div>
                <div>
                  <button *ngIf="getSubOptionsFormArray(optionIndex).length == 0" class="button button-outlined-primary button-xs" (click)="addElementOption(optionCtrl)">Agregar Element Option</button>
                  <!--<button mat-button (click)="addElementOption(optionCtrl)">Agregar Element Option</button>-->
                </div>
                <div>
                  <button class="button button-secondary button-xs" (click)="addNewOption()" title="Agregar opción">
                    <i class="fas fa-plus" aria-hidden="true"></i>
                  </button>
                  <!--<button mat-button (click)="addNewOption()">Agregar Opción</button>-->
                </div>
              </div>
              <div *ngIf="getSubOptionsFormArray(optionIndex).length > 0" class="elements-options" formArrayName="elements">
                <app-element-option-create *ngFor="let subOptionCtrl of getSubOptionsFormArray(optionIndex).controls" [formGroup]="getOptionFormGroup(subOptionCtrl)" (remove)="removeOption(optionIndex)"></app-element-option-create>
                <div class="flex justify-end">
                  <button class="button button-primary button-xs" (click)="addElementOption(optionCtrl)">Agregar Element Option</button>
                </div>
              </div>
            </div>

            <!--
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>Opción</mat-label>
                <mat-select formControlName="id">
                  <mat-option *ngFor="let option of options" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
                <div *ngIf="optionCtrl.get('id')?.invalid && optionCtrl.get('id')?.touched" class="text-red-500">
                  Opción es requerida.
                </div>
              </mat-form-field>
              <button mat-button (click)="addElementOption(optionCtrl)">Agregar Element Option</button>
              <div formArrayName="elements">
                <app-element-option-create *ngFor="let subOptionCtrl of getSubOptionsFormArray(optionIndex).controls" [formGroup]="getOptionFormGroup(subOptionCtrl)" (remove)="removeOption(optionIndex)"></app-element-option-create>
              </div>
            -->
          </div>
        </div>
        <!--<button mat-button (click)="addNewOption()">Agregar Opción</button>-->
      </div>
    </div>
  </mat-expansion-panel>
</div>
